import React from 'react';

//CORE COMPONENTS
import { Image } from '../../../components-core/packages/components-core/dist/image';
import { Text, TextAppearance,TextAlignment } from '../../../components-core/packages/components-core/dist/text';
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';

//BUTTON
import { Link } from '../../../components-core/packages/components-core/dist/link';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container';

//ICONS
import { ArrowRight } from '../../../components-core/packages/icons-core/dist/ArrowRight';


const TopContainer = styled.div`
    width: 100vw;
`;

class Campaigns extends React.Component {

    renderHead(){
        return(
            <Container
            padding={padding4Dimensions}
            horizontalAlign={ContainerHorizontalAlignment.center}
        >
            <h2><Text  bold textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                <b>Kampanya ve hizmetler</b>
            </Text></h2>
        </Container>
        )
    }


    render() {
        return(
            <TopContainer>
                {this.renderHead()}
            </TopContainer>
        )
    }
}



const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

export default Campaigns;